import { httpInterceptor } from '../http-interceptor';

export class InspectionPlanService {
  static ENDPOINTS = {
    GET_ALL: 'inspectionplan/getinspectionlist',
    CREATE: 'inspectionplan/createinspectionplan',
    PARTS: 'mobile/parts',
    DELETE: 'shipment/delete',
    GET_BY_ID: 'inspectionplan/getinspectiondetails',
    EXTEND: 'inspectionplan/extendinspectionplan',
    CREATE_QUALITY_ALERT:'inspectionPlan/qualityalerts',
    GET_QUALITY_ALERTS:'inspectionPlan/getQualityAlerts',
    DELETE_QUALITYALERT_BY_ID:'inspectionPlan/deleteQualityAlert',
    DELETE_BY_MASTER_ID: 'inspectionplan/deleteInspectionPlansByMasterId',
    SAVE_PARAMETERS: 'inspectionplan/saveinspectionparameters',
    GET_PARAMETERS: 'inspectionplan/getinspectionparametersbypartid',
    DELETE_QUESTION: 'inspectionplan/softdeletequestion',
    DELETE_RESPONSE: 'inspectionplan/softdeleteresponse',
  };

  static async getAllInspectionPlan(data) {
    return httpInterceptor.post(this.ENDPOINTS.GET_ALL, data);
  }

  static async getInspectionPlanById(id) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_ID}/${id}`);
  }

  static async createInspectionPlan(data) {
    return httpInterceptor.post(this.ENDPOINTS.CREATE, data);
  }
  static async getParts() {
    return httpInterceptor.get(`${this.ENDPOINTS.PARTS}`);
  }
  static async extendInspectionPlan(data) {
    return httpInterceptor.post(this.ENDPOINTS.EXTEND, data);
  }
  static async createQualityAlert(data) {
    return httpInterceptor.post(this.ENDPOINTS.CREATE_QUALITY_ALERT, data);
  }
   static async getQualityAlertsByPartId(partId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_QUALITY_ALERTS}/${partId}`);
  }
 static async deleteQualityAlertById(alertId) {
  return httpInterceptor.delete(`${this.ENDPOINTS.DELETE_QUALITYALERT_BY_ID}/${alertId}`);
}

 static async deleteInspectionPlansByMasterId(inspectionPlanMasterId) {
  return httpInterceptor.delete(`${this.ENDPOINTS.DELETE_BY_MASTER_ID}/${inspectionPlanMasterId}`);
}

  static async saveInspectionParameters(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_PARAMETERS, data);
  }

  static async getInspectionParametersByPartId(inspectionPlanMasterId, partId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_PARAMETERS}/${inspectionPlanMasterId}/${partId || 0}`);
  }

  static async softDeleteQuestion(questionId) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE_QUESTION}/${questionId}`);
  }

  static async softDeleteResponse(responseId) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE_RESPONSE}/${responseId}`);
  }

}
